import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Select } from 'antd'

const Option = Select.Option

class StateDropdown extends Component {

  onSelect = (value) => 
    this.props.onSwitchStatefilter(value);

  render() {
    const { options, filter } = this.props
    const opt = options.map(opt => {
      return (
        <Option key={opt.value} value={opt.value}>
          {opt.icon} {opt.display}
        </Option>
      )
    })

    return (
      <Select 
        value={filter.selectedState}
        onChange={this.onSelect}
        className="filter-select"
      >
        {opt}
      </Select>
    )
  }
}

function mapStateToProps(state) {
  const { filter } = state
  return { filter }
}

function mapDispatchToProps(dispatch) {
  return {}
}

StateDropdown.defaultProps = {
  options: [{
    value: 'LAUNCHED,AWAITING_APPROVAL,QA_APPROVED,CLOSED,INVOICED,PAUSED,REJECTED',
    display: 'All States'
  }, {
    value: 'LAUNCHED,AWAITING_APPROVAL',
    display: 'Pending',
    icon: <i className='axiom-icon-icon icon-minus-circle warning'/>
  }, {
    value: 'QA_APPROVED,LAUNCHED,CLOSED,INVOICED,PAUSED',
    display: 'Approved',
    icon: <i className='axiom-icon-icon icon-check-circle success'/>
  }, {
    value: 'REJECTED',
    display: 'Rejected',
    icon: <i className='axiom-icon-icon icon-slash error'/>
  }],
  onSelect: () => {}
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(StateDropdown)